import type { InjectionKey } from 'vue'
import type { CheckboxGroupContext } from './types'

export const checkboxGroupContextKey: InjectionKey<CheckboxGroupContext> = Symbol('radioGroupKey')
